import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool';
import './index.less';
import { getDetailRecord } from '@/containers/content/util'
import { Descriptions } from 'antd'
import { AudienceGroupItem } from '@/components';
import { dynamicColumns } from './columns'

const { WizContainer, modelUtils, ossFileUtils } = framework_tool;
const { WizSpin, WizCard, WizEmpty, WizAlert, WizRow, WizCol, WizTable, WizModal, WizSearchBar, WizCollapse, WizDataTable } = component_tool;

const _getValue = (type, key) => {
  const values = {
    status: {
      0: '草稿',
      1: '已发布',
      2: '已关闭',
    },
    mode: {
      0: '随机练习',
      1: '顺序练习'
    },
    difficulty: {
      0: '低',
      1: '中',
      2: '高',
    },
    type: {
      0: '单选题',
      1: '多选题',
      2: '判断题',
    }
  }
  return values[type][key] || ''
}

class PracticeView extends WizContainer {
  componentName = 'PracticeView';

  constructor(props) {
    super(props);
    this.detailInfo = getDetailRecord(props.history);
    this.state = {
      id: this.detailInfo.id,
      record: this.detailInfo
    };
  }

  _componentDidMount = () => {
    let { id } = this.state
    this.doAction({
      path: 'practice/findById',
      payload: {
        key: 'practiceFullInfo',
        apiParams: { id }
      }
    })
  }

  propsAndStateOnChange = {
    practiceFullInfo: this._practiceFullInfo.bind(this)
  }

  _practiceFullInfo(nextProps, nextState) {
    let { practiceFullInfo } = nextProps
    if (practiceFullInfo && practiceFullInfo['success']) {
      let { info, targetScoreInfo, ruleList } = practiceFullInfo.data
      nextState.record = info
      nextState.ruleList = ruleList
      let data = Object.assign({}, targetScoreInfo)
      if (data['orgIds'] && data['orgIds'] instanceof Array) {
        data['orgIds'] = data['orgIds'].reduce((acc, cur, index) => {
          for (let i = 0; i < acc.length; i++) {
            const element = acc[i];
            if (element['categoryId'] === cur['categoryId']) {
              acc[i]['name'] = acc[i]['name'] + ',' + cur['name']
              return acc;
            }
          }
          return acc.concat({ id: cur['id'], name: cur['categoryName'] + ':' + cur['name'], categoryId: cur['categoryId'] })
        }, []);
      }
      data['message'] = [`受众人数：${data['scopeCount'] || 0}`, `已考人数：${data['successCount'] || 0}`]
      this.setState({
        targetScopeRecord: data,
      });
      return true
    } else {
      wizNotice.error(practiceFullInfo && practiceFullInfo['msg'] || '操作失败,请稍后尝试')
      return false
    }
  }

  _renderContentRow(ln, lv = '', rn, rv = '') {
    return (
      <WizRow className='administrationScope-row-item'>
        <WizCol className='col-item' span={3} offset={1}>{ln + '：'}</WizCol>
        <WizCol span={6}>{lv}</WizCol>
        <WizCol className='col-item' span={3} offset={2}>{rn + '：'}</WizCol>
        <WizCol span={9}>{rv}</WizCol>
      </WizRow>
    )
  }

  _render() {
    const { record, targetScopeRecord, ruleList } = this.state
    let { practiceLoading } = this.props
    let questionAllNum = 0
    if (Array.isArray(ruleList) && ruleList.length) {
      questionAllNum = ruleList.reduce((acc, item) => acc + item.size, 0);
      ruleList.forEach(d => {
          d.typeTitle = _getValue("type", d.type)
          d.difficultyTitle = _getValue("difficulty", d.difficulty)
        })
    }
    let message = (<React.Fragment>
      <span className="tips-font">共{questionAllNum || 0}题
        <text className="message-font">【仅能选择单选题、多选题、判断题】</text>
      </span> </React.Fragment>);
    return (
      <>
        <WizCard>
          <WizCollapse className='administrationScope-collapse'
            expandIconPosition='right'
            defaultActiveKey={[
              0
            ]}
          >
            <WizCollapse.Panel key={0} header={'基础信息'} className='panel-item'>
              {this._renderContentRow('练习名称', record['name'], '考试类型', '练习考试')}
              {this._renderContentRow('状态', _getValue('status', record.status), '考试分类', record.categoryName)}
              {this._renderContentRow('练习时间', record.startDate + ' ~ ' + record.endDate, '推送时间', record.pushTime.slice(0, 5))}
              {this._renderContentRow('练习模式', _getValue('mode', record.mode), '练习次数', record.count)}
            </WizCollapse.Panel>
            <WizCollapse.Panel key={1} header={'练习受众'} className='panel-item'>
              <WizSpin tip={'加载中'} spinning={practiceLoading}>
                <AudienceGroupItem {...targetScopeRecord} showMessage={true} />
              </WizSpin>
            </WizCollapse.Panel>
            <WizCollapse.Panel key={2} header={'习题信息'} className='panel-item'>
              <Descriptions column={1}>
                <Descriptions.Item label='练习周期'>{record.days}</Descriptions.Item>
                <Descriptions.Item label='每日抽题数量'>{record.questionNum}</Descriptions.Item>
              </Descriptions>
              <WizAlert
                type="info"
                message={message}
                showIcon
                style={{ margin: 10 }}
              />
              <WizTable columns={dynamicColumns(this)}
                        dataSource={ruleList} 
                        />
            </WizCollapse.Panel>
          </WizCollapse>
        </WizCard>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { practice } = state;
  const practiceFullInfo = modelUtils.getModelEntity(practice, 'practiceFullInfo');
  const load = modelUtils.getLoadingState(state, 'practice');
  return {
    practiceFullInfo,
    ...load,
  };
};

export default connect(mapStateToProps)(PracticeView);